import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

const componentButtonStyle1 = css`
  color: ${theme.font.colors.default};
  font-weight: ${theme.font.weight.regular};
  &:hover,
  &:active,
  &:focus {
    background-color: ${theme.colors.neutral20};
  }
  padding: ${theme.spacing(1)};
`;

export const SettingsBulkActionButtonStyles = {
  componentButtonStyle1,
};
